// Shared, plain (non-SCSS) CSS so the exact same look can be injected into a foreign
// parent document (Fusion-View host page) via <style>, not just used by the Angular component.
// Class names are prefixed to avoid clashing with CSS already loaded on arbitrary LMS pages.
// Icons are plain unicode glyphs (not an icon font) - remix icon font isn't reliably loaded
// on arbitrary Fusion-View host pages, so this avoids that dependency entirely.
export const MIC_PERMISSION_OVERLAY_STYLES = `
.ragai-mic-permission-overlay {
  position: fixed;
  top: 0;
  left: 0;
  width: 100%;
  height: 100%;
  background-color: rgba(10, 10, 10, 0.97);
  color: white;
  display: flex;
  justify-content: center;
  align-items: center;
  z-index: 2147483647;
  text-align: center;
  font-family: system-ui, sans-serif;
}

.ragai-mic-permission-content {
  display: flex;
  flex-direction: column;
  align-items: center;
  max-width: 360px;
  padding: 0 16px;
  box-sizing: border-box;
}

.ragai-mic-permission-icon {
  font-size: 2.5rem;
  line-height: 1;
  margin-bottom: 8px;
  color: #ffc107;
}

.ragai-mic-permission-description {
  margin-top: 6px;
  font-size: small;
}

.ragai-mic-permission-hint {
  margin-top: 18px;
  padding: 12px 16px;
  background-color: rgba(255, 193, 7, 0.1);
  border: 1px solid rgba(255, 193, 7, 0.35);
  border-radius: 10px;
  font-size: small;
  line-height: 1.4;
  text-align: center;
}

.ragai-mic-permission-btn {
  display: inline-flex;
  align-items: center;
  gap: 6px;
  background-color: #e9ecef;
  color: #111;
  margin-top: 16px;
  padding: 8px 20px;
  border: 1px solid transparent;
  border-radius: 6px;
  cursor: pointer;
  font: inherit;
  font-size: 0.9rem;
  transition: background-color 0.15s ease, transform 0.05s ease;
}

.ragai-mic-permission-btn:hover {
  background-color: #d3d7db;
}

.ragai-mic-permission-btn:active {
  background-color: #c3c7cb;
  transform: scale(0.98);
}
`;
